<template>
    <div v-observe-visibility="visibilityChanged">
        <v-layout row justify-center>
            <v-dialog v-model="removeDialog" persistent max-width="350">
                <v-card>
                    <v-card-title class="headline">Delete item?</v-card-title>
                    <v-card-text>This action deletes selected item from Database, be carefull!</v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary darken-1" flat @click.native="removeDialog = false">Cancel</v-btn>
                        <v-btn color="primary darken-1" flat
                               @click.native="removeBranchOffice(branchOfficeToDelete)">OK
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>

        <v-layout row wrap ma-2>
            <v-flex xs12 md3 ma-2>
                <v-flex xs12>
                    <v-card dark color="secondary" mb-0>
                        <v-card-title>Branch Offices</v-card-title>
                    </v-card>
                    <v-progress-linear class="branch-office-loading" :active="loading"
                                       :indeterminate="true"></v-progress-linear>
                </v-flex>
                <v-list class="branchOfficesList" two-line subheader>
                    <template v-for="(item, index) in manufacturerBranchOffices">
                        <v-list-tile avatar
                                     @click="editBranchOffice(index)">
                            <v-list-tile-avatar>
                                <v-icon>business_center</v-icon>
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                                <v-list-tile-title>{{item.name}}
                                </v-list-tile-title>
                                <v-list-tile-sub-title>{{item.city}} - {{item.zipcode}} - {{item.country}}
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                                <v-btn icon ripple @click="showDeleteBranchOfficeDialog(index)">
                                    <v-icon color="red lighten-1">delete</v-icon>
                                </v-btn>
                            </v-list-tile-action>
                        </v-list-tile>
                        <v-divider></v-divider>
                    </template>
                </v-list>
                <v-flex v-if="manufacturerBranchOffices == null || manufacturerBranchOffices.length <= 0">
                    <v-card-text><p class="text-xs-center grey--text">No Branch Offices yet</p></v-card-text>
                </v-flex>

                <v-layout mt-5 row justify-end>
                    <v-btn mt-5 dark color="secondary" @click="addNewBranchOffice">Add
                        <v-icon class="white--text" right>add</v-icon>
                    </v-btn>
                </v-layout>

            </v-flex>


            <v-flex xs12 md3 ma-2>
                <v-layout wrap>
                    <v-flex xs12>
                        <v-card dark color="secondary">
                            <v-card-title>General</v-card-title>
                        </v-card>
                    </v-flex>
                    <v-flex xs12>
                        <v-text-field :disabled="formDisabled"
                                      v-model="selectedBranchOffice.name"
                                      label="Name">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12>
                        <v-text-field :disabled="formDisabled"
                                      v-model="selectedBranchOffice.taxnumber"
                                      label="Tax number">
                        </v-text-field>
                    </v-flex>
                </v-layout>
            </v-flex>

            <v-flex xs12 md3 ma-2>
                <v-layout wrap>
                    <v-flex xs12>
                        <v-card dark color="secondary">
                            <v-card-title>Address</v-card-title>
                        </v-card>
                    </v-flex>

                    <v-flex md8 xs12>
                        <v-text-field :disabled="formDisabled"
                                      v-model="selectedBranchOffice.street"
                                      label="Street">
                        </v-text-field>
                    </v-flex>
                    <v-flex offset-md1 md3 xs12>
                        <v-text-field :disabled="formDisabled"
                                      v-model="selectedBranchOffice.hnumber"
                                      label="House number">
                        </v-text-field>
                    </v-flex>

                    <v-flex xs12>
                        <v-layout wrap>
                            <v-flex xs4 pr-3>
                                <v-text-field :disabled="formDisabled"
                                              v-model="selectedBranchOffice.zipcode"
                                              label="Postcode">
                                </v-text-field>
                            </v-flex>

                            <v-flex xs8 pr-0>
                                <v-text-field :disabled="formDisabled"
                                              v-model="selectedBranchOffice.city"
                                              label="City">
                                </v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-flex>

                    <v-flex xs12>
                        <v-autocomplete :disabled="formDisabled"
                                        :items="countries"
                                        label="Country"
                                        v-model="selectedBranchOffice.country"
                                        required
                        ></v-autocomplete>
                    </v-flex>
                </v-layout>

                <v-layout mt-5 row justify-end>
                    <v-btn :disabled="formEdited" mt-5 class="secondary white--text"
                           @click.native="saveBranchOfficeAndGoToNextTab(3)">Save
                        <v-icon class="white--text" right>save</v-icon>
                    </v-btn>
                </v-layout>

            </v-flex>
        </v-layout>

    </div>
</template>


<script>
    import {
        Settings,
        ManufacturersSettings,
        ManufacturerBranchOfficeSettings
    } from '../../../store/namespace-helper'

    export default {
      name: 'manufacturers-branch-offices',
      data () {
        return {
          countries: this.$store.getters.countries,
          isVisible: false,
          removeDialog: false,
          branchOfficeToDelete: null,
          onDismissed: false,
          branchOfficeUpdated: 0,
          formDisabled: true
        }
      },
      methods: {
        visibilityChanged (isVisible, entry) {
          if (this.isVisible !== isVisible) {
            this.isVisible = isVisible
            if (isVisible) {
              console.log('tab visible, load data')
              this.loadBranchOffices()
            } else {
              this.formDisabled = true
              this.branchOfficeUpdated = 0
              this.$store.dispatch(ManufacturerBranchOfficeSettings.actions.setSelectedBranchOffice, null)
              console.log('BranchOffices not visible!!!')
            }
          }
        },
        loadBranchOffices () {
          this.$store.dispatch(ManufacturerBranchOfficeSettings.actions.loadBranchOffices, this.selectedManufacturer.id)
        },
        editBranchOffice (index) {
          this.formDisabled = false
          this.$store.dispatch(ManufacturerBranchOfficeSettings.actions.setSelectedBranchOffice, this.manufacturerBranchOffices[index])
        },
        showDeleteBranchOfficeDialog (index) {
          this.removeDialog = true
          this.branchOfficeToDelete = index
        },
        removeBranchOffice (index) {
          this.removeDialog = false
          this.$store.dispatch(ManufacturerBranchOfficeSettings.actions.removeBranchOffice, this.branchOfficeToDelete)
          this.branchOfficeUpdated = 0
          this.formDisabled = true
          this.selectedBranchOffice.name = ''
        },
        addNewBranchOffice () {
          let branchOffice = {
            id: 0,
            name: 'New Branch Office',
            taxnumber: null,
            street: null,
            hnumber: null,
            city: null,
            zipcode: null,
            contry: null,
            manufacturers_id: this.selectedManufacturer.id
          }
          this.$store.dispatch(ManufacturerBranchOfficeSettings.actions.addNewBranchOffice, branchOffice)
          this.$store.dispatch(ManufacturerBranchOfficeSettings.actions.setSelectedBranchOffice, branchOffice)
        },
        saveBranchOfficeAndGoToNextTab (index) {
          this.$store.dispatch(ManufacturerBranchOfficeSettings.actions.saveBranchOffices, this.manufacturerBranchOffices)
          this.branchOfficeUpdated = 0
        }

      },
      computed: {
        selectedManufacturer () {
          return this.$store.getters[ManufacturersSettings.getters.getSelectedManufacturer]
        },
        manufacturerBranchOffices () {
          return this.$store.getters[ManufacturerBranchOfficeSettings.getters.getBranchOffices]
        },
        selectedBranchOffice () {
          return this.$store.getters[ManufacturerBranchOfficeSettings.getters.getSelectedBranchOffice]
        },
        loading () {
          return this.$store.getters[Settings.getters.loading]
        },
        formEdited () {
          console.log('branch office formEdited: ' + this.branchOfficeUpdated)
          return this.branchOfficeUpdated < 2
        }
      },
      watch: {
        manufacturerBranchOffices: {
          handler (val) {
            console.log('manufacturerBranchOffices data changed: ' + JSON.stringify(val))
            this.branchOfficeUpdated++
          },
          deep: true
        }
      }
    }
</script>

<style scoped>
    .branchOfficesList {
        max-height: 50vh;
        overflow: scroll;
        margin-top: -20px;
    }

    .branchOfficesList::-webkit-scrollbar {
        display: none;
    }

    .branch-office-loading {
        margin-top: 0px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Settings/Manufacturers/ManufacturerBranchOffices.vue